import {DateTimePicker} from '@mui/x-date-pickers';
import React from 'react';
import {MuiPickerViewType} from "@ui/datePicker/muiDatePicker/types";
import moment from 'moment'
import {sx} from './sx'
import {Popper, PopperProps, Stack, Typography} from '@mui/material';
import MuiSelectHours from './selectHours/MuiSelectHours'
import MuiSelectHoursAndMinutes from "@ui/datePicker/muiDatePicker/selectHoursAndMinutes/MuiSelectHoursAndMinutes";
import {SxType} from "@baseTypes/sx/sxTypes";
interface IProps {
    views?: MuiPickerViewType[],
    value?: string,
    onChange: (value: string) => void,
    format?: string,
    label?: string,
    fullWidth?: boolean,
    disabled?: boolean,
    direction?: 'row' | 'column'
    alignItems?: 'center',
    sx?: SxType,
    inputFormat?: string
    showHoursAndMinutes?: boolean
    hasTime?: boolean
}



const PopoverCustom = (props: PopperProps) => {
    return (
        <Popper
            {...props}
            placement={'auto'}
            sx={{
                zIndex:1300
            }}
            
        />

    )

}

const MuiDatePicker = ({
                           views,
                           value,
                           onChange,
                           format,
                           label,
                           fullWidth,
                           disabled,
                           direction,
                           alignItems,
                           showHoursAndMinutes,
                           sx: sxProps = {},
                           inputFormat,
                           hasTime = true,

                       }: IProps) => {

        return (
            <Stack
                direction={direction}
                gap={'3px'}
                alignItems={alignItems}
                sx={{
                    ...sx.wrap,
                    width: fullWidth ? '100%' : 'auto',
                    ...sxProps,
                    maxWidth:fullWidth ? 'initial' : '190px',

                }}
            >
                {label && <Typography
                    variant={'body2'}
                >
                    {label}
                </Typography>}

                <DateTimePicker
                    value={moment(value, format)}
                    onChange={(value) => onChange(value.format(format))}
                    views={views ?? (hasTime ? ['year', 'month', 'day', 'hours'] : ['year', 'month', 'day'])}
                    format={format}
                    sx={sx.root}
                    disabled={disabled}
                    slots={{
                        popper: PopoverCustom,
                    }}
                    viewRenderers={{
                        //@ts-ignore
                        hours: hasTime ? showHoursAndMinutes ? MuiSelectHoursAndMinutes : MuiSelectHours : null,
                    }}
                    fullWidth={fullWidth}
                />
            </Stack>
        );
    }
;

export default MuiDatePicker;